import React, { memo } from 'react';
import TextField from 'components/Common/TextField';
import Styles from './index.module.css';

function PlayGround() {
  return (
    <div className={Styles.playGroundContainer}>
      <TextField />
    </div>
  );
}

export default memo(PlayGround);
